import ToolEntryButton from '~/components/toolbar/shared/ToolEntryButton';
import { useViewingToolEntries } from '~/components/toolbar/shared/useViewingToolEntries';

export default function BoxZoomTool() {
    const { boxZoom } = useViewingToolEntries();

    return <ToolEntryButton entry={boxZoom} />;
}
